import { FormikValues } from 'formik';
import React, { FC } from 'react';
import {
    Navigate,
    Route, Routes, useResolvedPath,
} from 'react-router-dom';
import { WizardFormProps, WizardStepProps } from './types';
import WizardRoutedStep from './WizardRoutedStep';

const WizardForm: FC<WizardFormProps> = (props: WizardFormProps) => {
    const {
        children,
        lastStepNextButtonTitle,
        nextButtonTitle,
        previousButtonTitle,
        locationAfterExit,
        locationOnCompletion,
        canSaveDraft,
        showSaveAndNextButton,
        showGoToDashboardButton,
        showBanner,
        confirmationOnSubmission,
    } = props;

    const url = useResolvedPath('').pathname;

    const reactChildren = React.Children.toArray(children).map((child) => {
        if (!React.isValidElement<WizardStepProps<FormikValues>>(child)) {
            throw new Error('WizardForm only accepts children of type WizardStep');
        }
        return child;
    });

    return (
        <Routes>
            {reactChildren.map((step, index) => {
                const {
                    initialValues,
                    location,
                    onSaveAndExit,
                    onSaveAndNext,
                    validateHard,
                    validateSoft,
                    stepStatuses,
                    loadStepValues,
                    title,
                    hidingFields,
                    bannerTitle,
                    bannerRefTitle,
                    bannerSubTitle,
                    getRedirectionLocationOnError,
                    isSummaryPage,
                    discard,
                    disableLinkedError,
                    suppressErrorSummary,
                    suppressErrorSummaryPath,
                } = step.props;
                return (
                    <Route
                        key={location}
                        path={location}
                        element={(
                            <WizardRoutedStep
                                allSteps={reactChildren.slice()}
                                currentStepIndex={index}
                                initialValues={initialValues}
                                location={location}
                                isSummaryPage={isSummaryPage}
                                locationAfterExit={locationAfterExit}
                                locationOnCompletion={locationOnCompletion}
                                onSaveAndExit={onSaveAndExit}
                                onSaveAndNext={onSaveAndNext}
                                title={title}
                                lastStepNextButtonTitle={lastStepNextButtonTitle}
                                stepStatuses={stepStatuses}
                                loadStepValues={loadStepValues}
                                nextButtonTitle={nextButtonTitle}
                                previousButtonTitle={previousButtonTitle}
                                validateHard={validateHard}
                                validateSoft={validateSoft}
                                url={url}
                                hidingFields={hidingFields}
                                bannerTitle={bannerTitle}
                                bannerRefTitle={bannerRefTitle}
                                bannerSubTitle={bannerSubTitle}
                                canSaveDraft={canSaveDraft}
                                showSaveAndNextButton={showSaveAndNextButton}
                                showGoToDashboardButton={showGoToDashboardButton}
                                discard={discard}
                                getRedirectionLocationOnError={getRedirectionLocationOnError}
                                showBanner={showBanner}
                                confirmationOnSubmission={confirmationOnSubmission}
                                suppressErrorSummary={suppressErrorSummary}
                                suppressErrorSummaryPath={suppressErrorSummaryPath}
                                disableLinkedError={disableLinkedError}
                            />
                        )}
                    />
                );
            })}
            <Route
                path='*'
                key={url}
                element={(
                    <Navigate to={`${url}${reactChildren[reactChildren.length - 1].props.location}`} replace />
                )}
            />
        </Routes>
    );
};

export default WizardForm;
